import { render, staticRenderFns } from "./TiShape.vue?vue&type=template&id=b011fd60&"
import script from "./TiShape.vue?vue&type=script&lang=js&"
export * from "./TiShape.vue?vue&type=script&lang=js&"
import style0 from "./TiShape.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports